import { MiamiFlow } from "@/pages/MiamiPage";
import {
  INDUSTRIES_ES,
  PEOPLE_BUCKETS_ES,
  CAPACITY_QUESTIONS_ES,
  CAPACITY_EXAMPLE_ES,
  getIndustryEs,
  MIAMI_ES,
} from "@/data/miamiConfigEs";

export default function EsMiamiPage() {
  return (
    <MiamiFlow
      industries={INDUSTRIES_ES}
      buckets={PEOPLE_BUCKETS_ES}
      questions={CAPACITY_QUESTIONS_ES}
      example={CAPACITY_EXAMPLE_ES}
      getIndustryFn={getIndustryEs}
      copy={MIAMI_ES}
      source="/es/miami"
    />
  );
}
